import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const DividerRule = ({ label, sx = {} }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        my: 4,
        ...sx,
      }}
    >
      <Box sx={{ flex: 1, height: '1px', backgroundColor: theme.palette.divider }} />
      {label && (
        <Typography
          variant="caption"
          sx={{
            fontFamily: '"JetBrains Mono", monospace',
            fontSize: '0.7rem',
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: theme.palette.text.secondary,
            px: 0.5,
          }}
        >
          {label}
        </Typography>
      )}
      {label && <Box sx={{ flex: 1, height: '1px', backgroundColor: theme.palette.divider }} />}
    </Box>
  );
};

export default DividerRule;
